import PageHero from "../components/PageHero";
import Contact from "../components/sections/Contact";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contact"
        accent="#FF6600"
        title={
          <>
            Let’s design what{" "}
            <span className="bg-[#FF6600] text-white px-2 inline-block">
              comes next.
            </span>
          </>
        }
        intro="Tell us about your school, library, council or program. We'll get back within 1–2 business days."
      />
      <Contact />
    </div>
  );
}
